import React from 'react';
import AsyncCoinContractABI from '../../../build/contracts/AsyncCoin';
import { ASYNC_NETWORK_ID } from '../../utils/Constants';
import { FINISH_STEP, GO_BACK_TO_STEP, } from '../../storage/TutorialReducer';

export default class TutorialStep2 extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      contractAddress: null
    };
  }

  componentDidMount () {
    this.setState({
      contractAddress: AsyncCoinContractABI.networks[ASYNC_NETWORK_ID].address
    });
  }

  goNext () {
    Storage.dispatch({type: FINISH_STEP, payload: 2});
  }

  goBack () {
    Storage.dispatch({type: GO_BACK_TO_STEP, payload: 1});
  }

  render () {
    return (
      <div className="c-tutorial-element">
        <h2 className="c-tutorial-element__subtitle">
          Ok, that's fine, but I'm not going to spend Ether on showcase
          Dapp
        </h2>
        <p>That's why AsyncCoin is deployed on Ropsten test network. You can view it on&nbsp;
          <a target="_blank"
             href={'https://ropsten.etherscan.io/token/' + this.state.contractAddress}>
            Etherscan
          </a>.
          If you need Ether, there is Get Ether page in the menu, or you can search for other Ether
          Ropsten faucets.
        </p>

        <div className="c-tutorial-element__button-container">
          <button onClick={this.goBack}>Back</button>
          <button onClick={this.goNext}>Next</button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Tutorial/TutorialStep2.js